import { IGetGameUrl } from '../../types/slot';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IWInfinityGetGameUrl, IWInfinityServerGame } from '../../types/interfaces/Slots/WInfinity';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<{ items: IWInfinityServerGame[] }>): ISlotViewItem[] =>
    data.items
      .filter(game => !game.isLiveGame)
      .map(game => ({
        imageUrl: `/images/winfinity/${game.id}.png`,
        tab: [],
        gameId: game.id,
        provider: game.providerName,
        description: game.name,
        gameName: game.name,
        routeProvider: 'winfinity',
        type: CasinoType.slots,
        id: game.id,
      }));

  convertGameUrl = ({ data }: IGetGameUrl<IWInfinityGetGameUrl, unknown>) => data.url;
}

export default Converter;
